import React from 'react';
import CreateRequestComponent, {
	Props
} from '@websky/core/src/Modules/Exchange/components/Exchange/CreateRequest/CreateRequest';

const CreateRequest: React.FC<Props> = props => {
	return <CreateRequestComponent {...props} isRulesOptional={true} />;
};

export default CreateRequest;
